/* src/app/shared-components/power-bi/power-bi.component.scss */
.container-power-bi {
  overflow-y: hidden;
  height: calc(100% - 96px);
}
.scrollbar {
  overflow-y: auto;
}
/*# sourceMappingURL=power-bi.component.css.map */
